import { IconImage } from '@/core/features';

type MapLayereSelectionOptionProps = {
    active: boolean;
    imageUrl: string;
    label: string;
    onOptionClick: () => void;
};

export default function MapLayerSelectionOption({
    active,
    imageUrl,
    label,
    onOptionClick,
}: MapLayereSelectionOptionProps) {
    return (
        <div
            className={'flex flex-col items-center gap-10'}
            data-qa-id={'qa-map-layer-switch-option'}
            onClick={onOptionClick}
            /* eslint-disable-next-line no-inline-styles/no-inline-styles */
            style={{ aspectRatio: 1, width: 67 }}
        >
            <IconImage
                alt={''}
                className={`${active ? 'border-endeavour' : 'border-transparent'} border rounded-[50%] overflow-hidden`}
                height={67}
                url={imageUrl}
                width={67}
            />
            <span className={`text-14 ${active ? 'text-endeavour' : ''}`}>{label}</span>
        </div>
    );
}
